import React from 'react';
import { Fit, ItemText, fs } from '../parts/fields';
import { Head, Logo } from '../parts/chrome';
import { items, useSlide } from '../parts/context';
import { fill, sizeStep } from '../text';

// #region StatsLayout
/** Two to four big numbers. Every value shares one size (set by the longest) so the row reads as a set. */
export const StatsLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, context, mode } = useSlide();
    const list = items(slide.fields.items);
    const n = Math.max(1, list.length);
    const longest = list.reduce((m, it) => Math.max(m, fill(it.value ?? '', context.values, mode).length), 0);
    const size = sizeStep('x'.repeat(longest), n >= 4 ? [[4, 140], [6, 116], [9, 92], [999, 76]] : [[4, 176], [6, 144], [9, 116], [999, 96]]);
    return (
        <>
            <div className="wd-pad">
                <Head />
                <Fit style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`, width: '100%' }}>
                        {list.map((_, i) => (
                            <div key={i} style={{ minWidth: 0, padding: i === 0 ? '8px 56px 8px 0' : '8px 56px', borderLeft: i === 0 ? 'none' : '2px solid var(--wd-line)' }}>
                                <ItemText index={i} part="value" className="wd-num" style={{ fontSize: fs(size), lineHeight: 1, color: 'var(--wd-accent)', whiteSpace: 'nowrap' }} placeholder="00" max={16} />
                                <ItemText index={i} part="label" className="wd-lead wd-clamp" style={{ fontSize: fs(n >= 4 ? 26 : 30), marginTop: 28, color: 'var(--wd-body)', maxWidth: 440 }} placeholder="What the number means" max={60} />
                            </div>
                        ))}
                    </div>
                </Fit>
            </div>
            <Logo />
        </>
    );
};
